module.exports = __webpack_public_path__ + "img/60bbdd4a5bf647fef38d9b630fffceba.png";